import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-value"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "ongoing-order-inner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { reactive, watch, computed, onMounted } from 'vue';
    import { OrderStore } from '@/stores/order';
    import { AppStore } from '@/stores/app';
    import router from '@/router';
    import {PaidOrder} from "@/types";

    interface State {
        visible: boolean,
        count: number
    }

    /* Reactive */
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PaidOrderIcon',
  setup(__props) {


    /* imports */
    const orderStore = OrderStore();
    const appStore = AppStore();

    /* interface */
    const state = reactive<State>({
        visible: false,
        count: 0
    });

    /* Watch */
    watch(() => orderStore.state, () => {
        setState();
    }, { deep: true });

    /* Ref */

    /* Computed */
    const visible = computed(() => {
        return state.visible && !(appStore.state.currentPage === 'orderPage' || appStore.state.currentPage === 'ordersPage');
    });

    /* Refs */

    /* Functions */
    const onClick = () => {
        //If there are several orders, forward the user to ordersPage, but if there is only one order, forward them to orderPage.

       const orders = orderStore.ordersCount;

        if (state.count === 1 && orderStore.state.paidOrders.length == 1) {
           const order: PaidOrder = orderStore.state.paidOrders[0];

           router.push({
               name: 'orderPage',
               params: { orderId: order.id }
           });

        } else if (state.count === 1 && orderStore.state.deliveredOrders.length == 1) {
           const order: PaidOrder = orderStore.state.deliveredOrders[0];
           router.push({
               name: 'orderPage',
               params: { orderId: order.id }
           });
        }
        else
            if (state.count !== 0) {
            router.push({
                name: 'ordersPage'
            });
        }        
    }

    const setState = () => {      

        state.count = orderStore.ordersCount;
        state.visible = (state.count > 0); 
    }

    /* Lifecycle Hooks */
    onMounted(() => setState())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(visible))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "ongoing-order",
            "data-value": state.count,
            onClick: onClick
          }, _hoisted_3, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})